import { render, staticRenderFns } from "./sensoryReportDetail.vue?vue&type=template&id=bbd850b2&scoped=true"
import script from "./sensoryReportDetail.vue?vue&type=script&lang=js"
export * from "./sensoryReportDetail.vue?vue&type=script&lang=js"
import style0 from "./sensoryReportDetail.vue?vue&type=style&index=0&id=bbd850b2&lang=scss&scoped=true"
import style1 from "./sensoryReportDetail.vue?vue&type=style&index=1&id=bbd850b2&lang=css"
import style2 from "./sensoryReportDetail.vue?vue&type=style&index=2&id=bbd850b2&scoped=true&lang=scss"
import style3 from "./sensoryReportDetail.vue?vue&type=style&index=3&id=bbd850b2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd850b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbd850b2')) {
      api.createRecord('bbd850b2', component.options)
    } else {
      api.reload('bbd850b2', component.options)
    }
    module.hot.accept("./sensoryReportDetail.vue?vue&type=template&id=bbd850b2&scoped=true", function () {
      api.rerender('bbd850b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory/sensory-report/sensoryReportDetail.vue"
export default component.exports